module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av681-c50a0439dbaab617d6c3cde53e634e53.jpg";